export const drawerWidth=250;
export const USER_TOKEN='user_token';
export const USER_ID='userId';
export const USER_EMAIL='email'
